import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SeguimientoRoutingModule } from './seguimiento-routing.module';
import { SharedModule } from '../../shared/shared.module';
import { CuadroMandoIntegralComponent } from './cuadro-mando-integral/cuadro-mando-integral.component';
import { ProyectosEstrategicosComponent } from './proyectos-estrategicos/proyectos-estrategicos.component';
import { PlanesComponent } from './planes/planes.component';
import { ObjetivosComponent } from './objetivos/objetivos.component';
import { IndicadoresMetasComponent } from './indicadores-metas/indicadores-metas.component';
import { ActasComponent } from './actas/actas.component';
import { EstrategiasComponent } from './estrategias/estrategias.component';

@NgModule({
  declarations: [
    CuadroMandoIntegralComponent,
    ProyectosEstrategicosComponent,
    ObjetivosComponent,
    PlanesComponent,
    IndicadoresMetasComponent,
    ActasComponent,
    EstrategiasComponent
  ],
  imports: [
    CommonModule,
    SeguimientoRoutingModule,
    SharedModule
  ]
})
export class SeguimientoModule { }
